/**
 * Image lazy loading component
 *
 * @module app/components/LazyLoadingImage
 */
import _ from 'lodash';
import MessageBusTopics from '../../common/MessageBusTopics';

/**
 * The name of a class for image, which should be lazy loaded
 *
 * @type   {String}
 *
 * @private
 */
var LAZY_LOADING_IMAGE_CLASS = 'lazy-loading-image';

/**
 * The name of a attribute for image, which should be lazy loaded
 *
 * @type   {String}
 *
 * @private
 */
var LAZY_LOADING_IMAGE_DATA_ATTR = 'data-src';

/**
 *
 *
 * @type {boolean}
 *
 * @private
 */
var ADDED_INIT_TRIGGER_LISTENERS = false;

/**
 * Initialize lazy loading images
 *
 * @returns {void}
 *
 * @private
 */
var init = function init() {

    lazyLoadImages(getImages());
};

/**
 * Lazy loading given images
 *
 * @param   {Array} images The collection of image DOM elements
 *
 * @private
 */
var lazyLoadImages = function lazyLoadImages(images) {

    _.each(images, lazyLoadImage);
};

/**
 * Lazy loading given image
 *
 * @param   {Object} image The image DOM element
 *
 * @private
 */
var lazyLoadImage = function lazyLoadImage(image) {

    var src = image.getAttribute(LAZY_LOADING_IMAGE_DATA_ATTR);

    if (src && image.tagName.toLowerCase() === 'img') {

        image.addEventListener('load', loadSuccessHandler);
        image.addEventListener('error', loadErrorHandler);
        image.setAttribute('src', src);
    }
};

/**
 * Loading image success handler
 *
 * @returns {void}
 *
 * @private
 */
var loadSuccessHandler = function loadSuccessHandler() {

    this.classList.remove(LAZY_LOADING_IMAGE_CLASS);
    removeEvents(this);
};

/**
 * Loading image error handler
 *
 * @returns {void}
 *
 * @private
 */
var loadErrorHandler = function loadErrorHandler() {

    removeEvents(this);
};

/**
 * Removing events
 *
 * @param   {Object} image The image DOM element
 *
 * @private
 */
var removeEvents = function removeEvents(image) {

    image.removeEventListener('load', loadSuccessHandler);
    image.removeEventListener('error', loadErrorHandler);
};

/**
 * Getting images to lazy load
 *
 * @returns {Array}
 *
 * @private
 */
var getImages = function getImages() {

    return document.getElementsByClassName(LAZY_LOADING_IMAGE_CLASS);
};

/**
 * Methods to be public
 *
 * @type   {Object}
 *
 * @public
 */
var api = {

    /**
     * Initialize lazy loading module
     *
     * @returns {void}
     *
     * @public
     */
    init: function () {

        init();
        if (!ADDED_INIT_TRIGGER_LISTENERS) {
            api.addListeners();
        }
    },

    /**
     * Adds pub sub listeners which trigger the init. This is used
     * for example by betslip receipt tabs, which after loading
     * next off selections need to trigger the lazy loading of silks
     *
     * @returns {void}
     *
     * @public
     */
    addListeners: function () {

        window.WH.messageBus.subscribe(MessageBusTopics.SELECTION_VIEW_ADAPTER_SELECTIONS_LOADED, init);
        ADDED_INIT_TRIGGER_LISTENERS = true;
    },
};


export default api;
